import {
  BarChart3Icon,
  CheckIcon,
  HeadphonesIcon,
  InfinityIcon,
  KeyIcon,
  SparklesIcon,
  UserIcon,
  UsersIcon,
} from 'lucide-react'
import type { ReactNode } from 'react'

import { BenefitItem } from './benefit-item.atom'

interface ProFeatureCheckItemProps {
  text: string
}

const ProFeatureCheckItem: React.FC<ProFeatureCheckItemProps> = ({ text }): ReactNode => (
  <div className="flex items-center gap-2">
    <CheckIcon className="size-4 text-primary" />
    <span className="text-sm">{text}</span>
  </div>
)

export const UpgradePlanHighlights: React.FC = (): ReactNode => (
  <div className="flex flex-col gap-4">
    <BenefitItem
      icon={InfinityIcon}
      title="Unlimited chats"
      description="No limits on conversations with AI agents"
    />
    <BenefitItem
      icon={SparklesIcon}
      title="Advanced agents"
      description="Access to all premium AI agents and capabilities"
    />
    <BenefitItem
      icon={UsersIcon}
      title="Team collaboration"
      description="Work together with your team in shared workspaces"
    />
  </div>
)

export const UpgradePlanFeatureList: React.FC = (): ReactNode => (
  <div className="flex flex-col gap-3">
    <ProFeatureCheckItem text="Unlimited chats" />
    <ProFeatureCheckItem text="Priority support" />
    <ProFeatureCheckItem text="Advanced API access" />
    <ProFeatureCheckItem text="Custom agents" />
    <ProFeatureCheckItem text="Team collaboration" />
    <ProFeatureCheckItem text="Analytics dashboard" />
    <ProFeatureCheckItem text="Dedicated account manager" />
  </div>
)

export const UpgradePlanAllFeatures: React.FC = (): ReactNode => (
  <div className="flex flex-col gap-4">
    <BenefitItem
      icon={InfinityIcon}
      title="Unlimited chats"
      description="No limits on conversations with AI agents"
    />
    <BenefitItem
      icon={HeadphonesIcon}
      title="Priority support"
      description="Get help faster with dedicated support channels"
    />
    <BenefitItem
      icon={KeyIcon}
      title="Advanced API access"
      description="Full access to all API features and higher rate limits"
    />
    <BenefitItem
      icon={SparklesIcon}
      title="Custom agents"
      description="Create and customize your own AI agents"
    />
    <BenefitItem
      icon={UsersIcon}
      title="Team collaboration"
      description="Work together with your team in shared workspaces"
    />
    <BenefitItem
      icon={BarChart3Icon}
      title="Analytics dashboard"
      description="Track usage, costs, and performance metrics"
    />
    <BenefitItem
      icon={UserIcon}
      title="Dedicated account manager"
      description="Personal support for your organization's needs"
    />
  </div>
)
